/*global moment*/
import React from 'react'
import { connect } from 'react-redux'
import {
  getLoanApplication,
  getMobile,
  getResidentialHistoryIds,
  getResidentialHistories,
  getEmail,
  getFirstName,
  getMiddleName,
  getSurname,
  getErrorMessage
} from '../../../reducers'
import { scrollToTop } from 'servos/formHelpers'
import {
  inValidDate,
  getAge,
  isMobile,
  getDateInputmask,
  isNumericOnly
} from 'servos/formValidations'
import {
  buildResidentialHistory,
  updateProfileStart
} from '../../../actions'

import Spinner from 'components/Spinner'
import PersonalDetails from './PersonalDetails/PersonalDetails'
import ContactDetails from './ContactDetails/ContactDetails'
import Documentation from './Documentation/Documentation'
import Identity from './Identity'
import Residential from './Residential/Residential'
import ActionButtons from '../../commons/ActionButtons'

class Profile extends React.Component {
  state = {
    errors: this.props.errors || {},
    documentationType: [],
    firstName: null,
    midName: null,
    lastName: null,
    mobile: null,
    dateOfBirth: null,
    driverLicenseNumber: null,
    stateOfIssue: null,
    intPassportNumber: null,
    countryOfIssue: null,
    ausPassportNumber: null,
    medicareCardNumber: null,
    medicareRefNumber: null,
    medicareMiddlenameOnCard: null,
    medicareCardColour: null,
    medicareValidTo: null,
    dateFormat: 'dd/mm/yyyy',
    identityVerification: null,
    medicarePreFilledName: null,
    locationAddress: null,
    locationSuburb: null,
    locationPostcode: null,
    locationState: null,
    coords: null,
  }

  componentDidMount() {
    window.scrollTo({top: 0})
  }

  componentWillMount() {
    const {
      profile,
      firstName,
      mobile,
      middleName,
      lastName
    } = this.props

    const {
      driverLicenseNumber,
      stateOfIssue,
      intPassportNumber,
      countryOfIssue,
      ausPassportNumber,
      medicareCardNumber,
      medicareMiddlenameOnCard,
      medicareCardColour,
      documentationType,
      identityVerification,
      medicareReferenceNumber: medicareRefNumber,
      medicareValidToInputmask: medicareValidTo,
      dateOfBirthInputmask: dateOfBirth,
    } = profile

    this.setState({
      mobile: (mobile ? mobile : ''),
      firstName: (firstName ? firstName : ''),
      midName: (middleName ? middleName : ''),
      lastName: (lastName ? lastName : ''),
      dateOfBirth: (dateOfBirth ? dateOfBirth : ''),
      medicareValidTo: medicareValidTo,
      medicareRefNumber: medicareRefNumber,
      driverLicenseNumber: driverLicenseNumber,
      stateOfIssue: stateOfIssue,
      intPassportNumber: intPassportNumber,
      countryOfIssue: countryOfIssue,
      ausPassportNumber: ausPassportNumber,
      medicareCardNumber: medicareCardNumber,
      medicareMiddlenameOnCard: medicareMiddlenameOnCard,
      medicareCardColour: medicareCardColour,
      documentationType: documentationType,
      identityVerification: identityVerification,
      dateFormat: (medicareCardColour === 'Green' ? 'mm/yyyy' : 'dd/mm/yyyy')
    });
  }

  componentWillUpdate(nextProps, nextState) {
    if (document.querySelector('#medicareValidTo')) {
      getDateInputmask(nextState.dateFormat, document.querySelector('#medicareValidTo'), 5)
    }

    if (nextProps.email !== this.props.email) {
      const {
        profile,
        firstName,
        mobile,
        middleName,
        lastName
      } = nextProps

      const {
        driverLicenseNumber,
        stateOfIssue,
        intPassportNumber,
        countryOfIssue,
        ausPassportNumber,
        medicareCardNumber,
        medicareMiddlenameOnCard,
        medicareCardColour,
        documentationType,
        identityVerification,
        medicareReferenceNumber: medicareRefNumber,
        medicareValidToInputmask: medicareValidTo,
        dateOfBirthInputmask: dateOfBirth,
      } = profile

      this.setState({
        mobile: (mobile ? mobile : ''),
        firstName: (firstName ? firstName : ''),
        midName: (middleName ? middleName : ''),
        lastName: (lastName ? lastName : ''),
        dateOfBirth: (dateOfBirth ? dateOfBirth : ''),
        medicareValidTo: medicareValidTo,
        medicareRefNumber: medicareRefNumber,
        driverLicenseNumber: driverLicenseNumber,
        stateOfIssue: stateOfIssue,
        intPassportNumber: intPassportNumber,
        countryOfIssue: countryOfIssue,
        ausPassportNumber: ausPassportNumber,
        medicareCardNumber: medicareCardNumber,
        medicareMiddlenameOnCard: medicareMiddlenameOnCard,
        medicareCardColour: medicareCardColour,
        documentationType: documentationType,
        identityVerification: identityVerification,
        dateFormat: (medicareCardColour === 'Green' ? 'mm/yyyy' : 'dd/mm/yyyy')
      });
    }
  }

  onNewAddressClick = (payload) => {
    this.props.buildResidentialHistory(payload)
  }

  validatePersonalDetails = (errors) => {
    const { firstName, lastName, dateOfBirth } = this.state
    if (!firstName) {
      errors['firstName'] = I18n.t('loan_application_user.profile.errors.first_name')
    }

    if (!lastName) {
      errors['lastName'] = I18n.t('loan_application_user.profile.errors.last_name')
    }

    if (!dateOfBirth) {
      errors['dateOfBirth'] = I18n.t('loan_application_user.profile.errors.date')
    }

    if (inValidDate(dateOfBirth) || dateOfBirth.split('/')[2] < 1928) {
      errors['dateOfBirth'] = I18n.t('loan_application_user.profile.errors.date')
    } else if (getAge(dateOfBirth) < 18) {
      errors['dateOfBirth'] = I18n.t('loan_application_user.profile.errors.age')
    } else {
      delete errors['dateOfBirth']
    }
  }

  setAddress = (addressData) => {
    const {
      locationAddress,
      locationSuburb,
      locationPostcode,
      locationState,
      coords,
    } = addressData

    this.setState({
      locationAddress,
      locationSuburb,
      locationPostcode,
      locationState,
      coords,
    })
  }

  validateContactDetails = (errors) => {
    const { mobile } = this.state
    if (mobile && !isMobile(mobile)) {
      errors['mobile'] = I18n.t('loan_application_user.profile.errors.mobile')
    }

    if (!mobile) {
      errors['mobile'] = I18n.t('loan_application_user.profile.errors.mobile')
    }
  }

  validateDocumentation = (errors) => {
    const {
      documentationType,
      ausPassportNumber,
      intPassportNumber,
      countryOfIssue,
    } = this.state

    documentationType.forEach((type) => {
      if (type === 'driverLicenseNumber') {
        this.validateDriverLicense(errors)
      } else if (type === 'ausPassportNumber' && !ausPassportNumber) {
        errors['ausPassportNumber'] = I18n.t('loan_application_user.profile.errors.passport_number')
      } else if (type === 'intPassportNumber' && !intPassportNumber && !countryOfIssue) {
        this.validateIntPassport(errors)
      } else if (type === 'medicare') {
        this.validateMedicare(errors)
      }
    })
  }

  validateMedicare = (errors) => {
    const {
      medicareCardNumber,
      medicareRefNumber,
      medicareCardColour,
      medicareValidTo,
    } = this.state
    if ((medicareCardNumber && !isNumericOnly(medicareCardNumber)) || !medicareCardNumber) {
      errors['medicareCardNumber'] = I18n.t('loan_application_user.profile.errors.medicare_card_number')
    }
    if ((medicareRefNumber && !isNumericOnly(medicareRefNumber)) || !medicareRefNumber) {
      errors['medicareRefNumber'] = I18n.t('loan_application_user.profile.errors.medicare_ref_number')
    }
    if (!medicareCardColour) {
      errors['medicareCardColour'] = I18n.t('loan_application_user.profile.errors.medicare_colour')
    }
    if (!medicareValidTo) {
      errors['medicareValidTo'] = I18n.t('loan_application_user.profile.errors.date')
    }
  }

  validateDriverLicense = (errors) => {
    const { driverLicenseNumber, stateOfIssue } = this.state
    if ((driverLicenseNumber && !isNumericOnly(driverLicenseNumber)) || !driverLicenseNumber) {
      errors['driverLicenseNumber'] = I18n.t('loan_application_user.profile.errors.driver_license')
    }
    if (!stateOfIssue) {
      errors['stateOfIssue'] = I18n.t('loan_application_user.profile.errors.state_of_issue')
    }
  }

  validateIntPassport = (errors) => {
    const { intPassportNumber, countryOfIssue } = this.state
    if (!intPassportNumber) {
      errors['intPassportNumber'] = I18n.t('loan_application_user.profile.errors.passport_number')
    }
    if (!countryOfIssue) {
      errors['countryOfIssue'] = I18n.t('loan_application_user.profile.errors.country_of_issue')
    }
  }

  validateResidentialHistory = (errors) => {
    const { residentialHistoryIds, residentialHistories } = this.props
    let totalMonths = 0

    residentialHistoryIds.forEach((id) => {
      if (residentialHistories[id].years == ('>3' || '3')) {
        totalMonths = 36
      } else {
        totalMonths = totalMonths + parseInt((residentialHistories[id].years * 12))
                     + parseInt(residentialHistories[id].months)
      }
    })

    if (totalMonths < 36) {
      errors['residentialHistory'] = I18n.t('loan_application_user.profile.errors.residential_history')
    }
  }

  isValid = () => {
    const { needsIdentityDocuments } = this.props

    let errors = {}

    this.validatePersonalDetails(errors)
    this.validateContactDetails(errors)
    this.validateResidentialHistory(errors)

    if (needsIdentityDocuments) {
      this.validateDocumentation(errors)
    }

    this.setState({ errors })
    return Object.keys(errors).length === 0
  }

  onContinueClick = () => {
    const {
      dateOfBirth,
      stateOfIssue,
      countryOfIssue,
      medicareCardColour,
      medicareValidTo,
      dateFormat,
    } = this.state
    const formattedDateOfBirth = dateOfBirth.split('/').reverse().join('/')

    if (this.isValid()) {
      this.props.updateProfileStart({
        user: {
          firstname: this.state.firstName,
          mobile: this.state.mobile,
          middlename: this.state.midName,
          surname: this.state.lastName,
        },
        profile: {
          dateOfBirth: new Date(formattedDateOfBirth).toString(),
          driverLicenseNumber: this.state.driverLicenseNumber,
          stateOfIssue: stateOfIssue ? stateOfIssue : null,
          intPassportNumber: this.state.intPassportNumber,
          countryOfIssue: countryOfIssue ? countryOfIssue : null,
          ausPassportNumber: this.state.ausPassportNumber,
          medicareCardNumber: this.state.medicareCardNumber,
          medicareReferenceNumber: this.state.medicareRefNumber,
          medicareMiddlenameOnCard: this.state.medicareMiddlenameOnCard,
          medicareCardColour: medicareCardColour ? medicareCardColour : null,
          //medicareValidTo: moment(medicareValidTo, dateFormat.toUpperCase()).format(),
          identityVerification: this.state.identityVerification,
        },
        currentApplicant: this.props.currentApplicant
      })
    } else {
      scrollToTop()
    }
  }

  handleStateOfIssue = ({value}) => {
    this.setState({ stateOfIssue: value })
  }

  handleCountryOfIssue = ({value}) => {
    this.setState({ countryOfIssue: value })
  }

  handleMedicareCardColour = ({value}) => {
    let { dateFormat } = this.state

    if (value === 'Green') {
      dateFormat = 'mm/yyyy'
    } else {
      dateFormat = 'dd/mm/yyyy'
    }

    document.querySelector('#medicareValidTo').value = ''
    this.setState({
      medicareCardColour: value,
      dateFormat,
      medicareValidTo: null,
    })
  }

  handleInput = (event) => {
    const { errors } = this.state
    this.setState({ [event.target.id]: event.target.value })

    if (event.target.id === 'mobile' && (event.target.value.length >= 10) && !isMobile(event.target.value)) {
      errors['mobile'] = I18n.t('loan_application_user.profile.errors.mobile')
    } else {
      delete errors['mobile']
    }

    this.setState({ errors })
  }

  handleIdentityVerification = (event) => {
    this.setState({ identityVerification: event.target.checked })
  }

  handleDocumentCheckbox = (event) => {
    let documentationType = this.state.documentationType
    const id = event.target.id
    const index = documentationType.indexOf(id)
    if (index === -1) {
      documentationType.push(id)
    } else {
      documentationType.splice(index, 1)
      this.setState({ [id]: '' })
    }

    if (id === 'medicare') {
      this.setState({
        medicareCardNumber: null,
        medicareRefNumber: null,
        medicareMiddlenameOnCard: null,
        medicareCardColour: null,
        medicareValidTo: null
      })
    } else if (id === 'intPassportNumber') {
      this.setState({ countryOfIssue: null })
    } else if (id === 'driverLicenseNumber') {
      this.setState({ stateOfIssue: null })
    }

    this.setState({ documentationType })
  }

  isDocumentationValid() {
    const {
      documentationType,
      driverLicenseNumber,
      stateOfIssue,
      intPassportNumber,
      countryOfIssue,
      ausPassportNumber,
      medicareCardNumber,
      medicareRefNumber,
      medicareCardColour,
      medicareValidTo,
    } = this.state

    const { needsIdentityDocuments } = this.props

    if (needsIdentityDocuments) {
      let isValid = false
      if (documentationType.length > 0) {
        documentationType.forEach((type) => {
          if (type === 'driverLicenseNumber' && driverLicenseNumber && stateOfIssue) {
            isValid = true
          } else if (type === 'ausPassportNumber' && ausPassportNumber) {
            isValid = true
          } else if (type === 'intPassportNumber' && intPassportNumber && countryOfIssue) {
            isValid = true
          } else if (type === 'medicare' && medicareCardNumber && medicareRefNumber
                     && medicareCardColour && medicareValidTo) {
            isValid = true
          } else {
            isValid = false
          }
        })
      }

      return isValid
    } else {
      return true
    }
  }

  isIdentityAuthorized() {
    const { needsEquifax } = this.props
    const { identityVerification } = this.state

    return( (needsEquifax) ? identityVerification : true )
  }

  continueEnabled() {
    let {
      firstName,
      mobile,
      dateOfBirth,
      lastName,
    } = this.state

    return(
      firstName &&
      lastName &&
      dateOfBirth &&
      mobile &&
      this.isDocumentationValid() &&
      this.isIdentityAuthorized()
    )
  }

  render() {
    const {
      errors,
      mobile,
      firstName,
      midName,
      lastName,
      documentationType,
      driverLicenseNumber,
      dateOfBirth,
      stateOfIssue,
      intPassportNumber,
      countryOfIssue,
      ausPassportNumber,
      medicareCardNumber,
      medicareRefNumber,
      medicareMiddlenameOnCard,
      medicareCardColour,
      medicareValidTo,
      identityVerification,
    } = this.state

    const {
      verifyIdentity: {
        showVerifyWait,
        showVerifyError,
      },
      email,
      name,
      residentialHistoryIds,
      needsIdentityDocuments,
      needsEquifax,
    } = this.props

    return (
      <div>
        {
          showVerifyWait &&
          <Spinner
            message={ 'Please wait as we verify your identity ...' }
          />
        }
        <h3>Okay {name}, tell us about yourself.</h3>
        <p className='grey big.mb-4'>We need a few personal details to verify your identity.</p>
        <PersonalDetails
          firstName={firstName}
          midName={midName}
          lastName={lastName}
          dateOfBirth={dateOfBirth}
          errors={errors}
          handleInput={this.handleInput}
        />
        <ContactDetails
          email={email}
          mobile={mobile}
          errorMessage={errors['mobile']}
          handleInput={this.handleInput}
        />
        <Residential
          residentialHistoryIds={residentialHistoryIds}
          onNewAddressClick={this.onNewAddressClick}
          errors={errors}
          setAddress={this.setAddress}
        />
        { (needsIdentityDocuments) &&
          <Documentation
            firstName={firstName}
            lastName={lastName}
            errors={ { ...errors, ...this.props.profile.errors } }
            handleDocumentCheckbox={this.handleDocumentCheckbox}
            handleStateOfIssue={this.handleStateOfIssue}
            handleCountryOfIssue={this.handleCountryOfIssue}
            handleMedicareCardColour={this.handleMedicareCardColour}
            handleInput={this.handleInput}
            stateOfIssue={stateOfIssue}
            intPassportNumber={intPassportNumber}
            countryOfIssue={countryOfIssue}
            ausPassportNumber={ausPassportNumber}
            driverLicenseNumber={driverLicenseNumber}
            documentationType={documentationType}
            medicareCardNumber={medicareCardNumber}
            medicareRefNumber={medicareRefNumber}
            medicareMiddlenameOnCard={medicareMiddlenameOnCard}
            medicareCardColour={medicareCardColour}
            medicareValidTo={medicareValidTo}
          />
        }
        {
          (needsEquifax) && (
            <Identity
              identityVerification={identityVerification}
              handleIdentityVerification={this.handleIdentityVerification}
              displayErrorMessage={ showVerifyError }
            />
          )
        }

        <ActionButtons
          continueEnabled={ this.continueEnabled() }
          onContinueClick={ this.onContinueClick }
          onGoBackClick={ this.props.onGoBackClick }
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    residentialHistoryIds: getResidentialHistoryIds(state),
    residentialHistories: getResidentialHistories(state),
    profile: state.profile,
    errorMessage: getErrorMessage(state),
    firstName: getFirstName(state),
    middleName: getMiddleName(state),
    lastName: getSurname(state),
    email: getEmail(state),
    mobile: getMobile(state),
    needsIdentityDocuments: getLoanApplication(state).needsIdentityDocuments && gon.loan_application.enable_verification,
    needsEquifax: getLoanApplication(state).needsEquifax,
    verifyIdentity: state.verifyIdentity,
  }
}

export default connect(mapStateToProps, {
  buildResidentialHistory,
  updateProfileStart
})(Profile)
